import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { ComboboxMulti } from "@/components/elements/Combobox";
import { TOption } from "@/types/common";
import { TLearningProgressFilterFormExtended } from "@/features/learning-progress/components/filter/learning-progress-filter-shared";

type TFilterKey = keyof TLearningProgressFilterFormExtended;

type ComboboxMultiFieldProps = {
  label: string;
  name: TFilterKey;
  options: TOption[];
  placeholder?: string;
};

export const ComboboxMultiField: FC<ComboboxMultiFieldProps> = ({ label, name, options, placeholder = "選択してください" }) => {
  const { control } = useFormContext<TLearningProgressFilterFormExtended>();

  return (
    <Stack spacing={0.5}>
      <Typography variant="cap12Light">{label}</Typography>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <ComboboxMulti
            placeholder={placeholder}
            value={(field.value as string[]) ?? []}
            onChange={field.onChange}
            options={options}
          />
        )}
      />
    </Stack>
  );
};
